import React from "react";

export interface CarouselArrowProps {
  isHidden: boolean;
  onClick: any;
  leftSide: boolean;
}
export class CarouselArrow extends React.Component<CarouselArrowProps> {
  render() {
    let className = "scc-carouselArrow swivl-svgButton";
    if (this.props.leftSide) {
      className += " scc-carouselLeftArrow swivl-gradientLeft";
    } else {
      className += " scc-carouselRightArrow swivl-gradientRight";
    }
    if (this.props.isHidden) {
      className += " scc-isHidden";
    }

    return (
      <div className={className} onClick={this.props.onClick}>
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: "16px", height: "28px" }}>
          <path d="M3.86,11.94l9-9A1.32,1.32,0,0,0,11,1.06L1.11,11a1.31,1.31,0,0,0-.38,1,1.31,1.31,0,0,0,.38,1l9.9,9.9A1.32,1.32,0,0,0,12.88,21Z" />
        </svg>
      </div>
    );
  }
}

// export interface CarouselDotsProps {
//   count:number;
//   index:number;
// }

// export class CarouselDot extends React.Component {
//   render () {
//   return <svg height="10" width="10">
//             <circle cx="5" cy="5" r="4" />
//           </svg>
//   }

// }

// export class CarouselDots extends React.Component<CarouselDotsProps> {

//     render() {
//       let dots = [];
//       for (let i = 0; i < this.props.count; i++) {
//         dots.push(<svg key={"dot_"+i} height="10" width="10" className={(i === this.props.index)?"scc-active":""}><circle cx="5" cy="5" r="4" /></svg>);
//       }
//       return <div className="scc-carouselDots">{dots}</div>
//     }
// }
